import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getPartner } from '../../service/partners/selector';
import PartnerContainer from '../PartnerContainer';
import { deepEqual } from '../../utils';
import Config from '../../Components/Config';
import { getData } from '../../service/partnersData/actions';
import ExternalIdAssignation from '../../Components/ExternalDataAssignation';
import { Button } from '@material-ui/core';
import ProductsSelector from '../../Components/ProductsSelector';
import { getProductsList } from '../../Components/ProductsSelector/Components/ProductsSelectorModal/selector';
import { bindActionCreators } from 'redux';
import { setSelected } from '../../Components/ProductsSelector/service/products/actions';
import PmsVariableServer from '../../Components/PmsVariableServer';

class Eviivo extends Component {
	componentDidMount() {
		if (this.props.partnerData.length === 0) {
			this.props.getPartnerData();
		}
	}

	validProductSelector = products => {
		let externalDataProduct = this.props.externalData.filter(
			e => e.model === 'id_product'
		);

		const idMenu = Object.keys(products)[0] || null;
		let selected = idMenu ? products[idMenu] : [];

		const firstFood = this.props.partnerData[0];

		if (firstFood) {
			const newProducts = selected.reduce((acc, id) => {
				if (!externalDataProduct.find(e => e.id_internal == id)) {
					acc.push({
						partner_prefix: this.props.partner.prefix,
						model: 'id_product',
						data_type: 'string',
						path: 'id',
						data: id,
						id_internal: id,
						id_external: firstFood.id,
						data_external: firstFood.id,
						data_type_external: 'string',
						path_external: 'id',
						active: 1,
					});
				}
				return acc;
			}, []);

			const deletedProducts = externalDataProduct
				.filter(e => e.active && !selected.includes(e.id_internal))
				.map(e => ({ ...e, active: 0 }));

			const reActivateProducts = externalDataProduct
				.filter(e => !e.active && selected.includes(e.id_internal))
				.map(e => ({ ...e, active: 1 }));

			for (let product of [
				...newProducts,
				...deletedProducts,
				...reActivateProducts,
			]) {
				this.props.patchExternalData(product);
			}
		}
	};

	setSelectedItems = _ => {
		let selectedProducts = this.props.externalData
			.filter(e => e.model === 'id_product' && e.active)
			.map(e => e.id_internal);
		let selectedProductsObject = selectedProducts.reduce((acc, id) => {
			let prod = this.props.products[id];
			if (prod) {
				if (!acc[prod.id_menu]) acc[prod.id_menu] = [];
				acc[prod.id_menu].push(id);
			}
			return acc;
		}, {});
		this.props.setSelectedAssignator(selectedProductsObject);
	};

	render() {
		const { partner, partnerData, products } = this.props;

		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				<Button
					style={{ margin: 10 }}
					variant="contained"
					color="primary"
					onClick={this.props.getPartnerData}>
					{I18n.t('partner.externalData.refreshData')}
				</Button>

				{partnerData && -partnerData.length ? (
					<>
						<h2>{I18n.t('partner.externalData.settingsProductTypes')}</h2>
						<ExternalIdAssignation
							prefix={partner.prefix}
							type="productType"
							externals={partnerData}
						/>

						<h2>{I18n.t('partner.externalData.settingsProduct')}</h2>
						{/* //TODO: externaliser le duo de composant (et le mettre dans eviivo et mews) */}
						<ProductsSelector
							onValid={this.validProductSelector}
							setSelectedItems={this.setSelectedItems}
							menuSelectorDisabled={true}
						/>
						<ExternalIdAssignation
							prefix={partner.prefix}
							type="productId"
							externals={partnerData}
							internals={this.props.externalData
								.filter(e => e.model === 'id_product' && e.active)
								.map(e => ({
									id: e.id_internal,
									name: this.props.productLoaded
										? products[e.id_internal] && products[e.id_internal].name
										: I18n.t('general.loading'),
								}))}
						/>
					</>
				) : (
					''
				)}

				<Config prefix_partner={partner.prefix || ''} />
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	const data = state.partnersData['eviivo'];
	const externalData = state.externalData['eviivo'] || [];
	let products = getProductsList(state);
	let _productsFlat = Object.keys(products).reduce((acc, id_menu) => {
		for (let id_product in products[id_menu]) {
			acc[id_product] = products[id_menu][id_product];
		}
		return acc;
	}, {});

	return {
		partner,
		partnerData:
			data && data.categories
				? data.categories.map(c => ({
						id: c.Id,
						name: c.LocalisedName,
					}))
				: [],

		externalData,
		products: _productsFlat,
		productLoaded: state.exports.productsSelector.products.loaded,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPartnerData: _ => dispatch(getData('eviivo')),
		patchExternalData: data => {
			dispatch({ type: 'PRE_PATCH_EXTERNAL_DATA', data });
		},
		setSelectedAssignator: bindActionCreators(setSelected, dispatch),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Eviivo);
